import TableCellMui from '@mui/material/TableCell/TableCell';
import { styled } from '@mui/system';

export const TableCellStyled = styled(TableCellMui)(() => ({
  backgroundColor: 'var(--color-element)',
  color: 'var(--color-type-primary)',
  '.icon-time [stroke]': {
    stroke: 'var(--color-type-primary)',
  },
}));
